export const ClientSocketEvents = {
    CONNECT_DIRECTOR: "connect_director",
    CONNECT_MODERATOR: "connect_moderator",
    CONNECT_USER: "connect_user",
    OPEN_PRODUCTION: "open_production",
    CLOSE_PRODUCTION: "close_production",
    CONNECT_TO_PRODUCTION: "connect_to_production",
    DISCONNECT_FROM_PRODUCTION: "disconnect_from_production",
    START_BROADCAST: "start_broadcast",
    STOP_BROADCAST: "stop_broadcast",
    SET_DIRECTION_INFO: "set_direction_info",
    SET_CLIENT_STATE: "set_client_state",
};
export const ServerSocketEvents = {
    INITIALIZED: "initialized",
    RECONNECTED: "reconnected",
    ACTION_SUCCESS: "action_success",
    NOTIFICATIONS: "notifications",
    SERVICE_ERROR: "service_error",
};
export const NotificationTypes = {
    CLIENT_INFO: "client_info",
    CLIENT_STATE: "client_state",
    PRODUCTIONS: "productions",
    PRODUCTION_STATE: "production_state",
    PRODUCTION_STATE_CHANGE: "production_state_change",
    PRODUCTION_INFO: "production_info",
    PRODUCTION_INFO_CHANGE: "production_info_change",
    STREAM_INFO: "stream_info",
    STREAM_INFO_CHANGE: "stream_info_change",
    DIRECTION_INFO: "direction_info",
    DIRECTION_INFO_CHANGE: "direction_info_change",
    CLIENTS: "clients",
    CLIENTS_CHANGE: "clients_change",
    ACTIONS: "actions",
    COMMANDS: "commands",
};
export const SocketState = {
    /** no state yet, not yet loaded or connected */
    NONE: 0,
    /** state after successful initialization of socket connection */
    CONNECTED: 1,
    /** user lost connection and is reconnecting */
    RECONNECTING: 2,
    /** user is disconnected */
    DISCONNECTED: 3,
};
export const ClientState = {
    NONE: 0,
    INIT: 1,
    CONNECTED: 2,
    CONNECTED_TO_PRODUCTION: 4,
    VIDEO: 8,
    WARNING: 16,
    ERROR: 32,
};
export const Contexts = {
    INITIALIZE: "initialize",
    RECONNECT: "reconnect",
    CONNECT: "connect",
    OPEN_PRODUCTION: "open_production",
    CLOSE_PRODUCTION: "close_production",
    CONNECT_TO_PRODUCTION: "connect_to_production",
    DISCONNECT_FROM_PRODUCTION: "disconnect_from_production",
    START_BROADCAST: "start_broadcast",
    STOP_BROADCAST: "stop_broadcast",
    SET_DIRECTION_INFO: "set_direction_info",
    SET_CLIENT_STATE: "set_client_state",
};
export const ConnectorEvents = {
    TOP_LEVEL: "adiacast.connector",
    SOCKET_ERROR: "adiacast.connector.socketError",
    SERVICE_ERROR: "adiacast.connector.serviceError",
    ACTION_SUCCESS: "adiacast.connector.actionSuccess",
    SOCKET_STATE: "adiacast.connector.socketState",
    CLIENT_STATE: "adiacast.connector.clientState",
    CLIENT_INFO: "adiacast.connector.clientInfo",
    PRODUCTIONS: "adiacast.connector.productions",
    PRODUCTION_STATE: "adiacast.connector.productionState",
    PRODUCTION_INFO: "adiacast.connector.productionInfo",
    DIRECTION_INFO: "adiacast.connector.directionInfo",
    STREAM_INFO: "adiacast.connector.streamInfo",
    ACTIONS: "adiacast.connector.actions",
    CLIENTS: "adiacast.connector.clients",
    NOTIFICATION: "adiacast.connector.notification",
    ONAIR_TIME_CHANGE: "adiacast.connector.onAirTimeChange",
    EXECUTE_COMMAND: "adiacast.connector.executeCommand",
};
